import { drawersBridge, apiBridge, solutionBridge } from '@gto/gw-store'
import { namespaces } from '@/helpers/constants'
import { SNK } from '@/helpers/helpers'
import { Store } from 'vuex'

export const connectXstateStore = (store: Store) => {
  drawersBridge.on('drawerOpened', event => {
    switch (event.drawer.id) {
      case 'uploads':
        store.dispatch('globals_drawer', {
          open: true,
          id: 'upload-boxes',
          tab: event.drawer.tab,
        })
        break

      case 'handDetails':
        store.dispatch('globals_drawer', {
          open: true,
          id: 'analyze_handV4',
          content: {
            hand_id: event.drawer.hand_id,
          },
        })
        break
      default:
        // Unknown drawer opened
        break
    }
  })

  drawersBridge.on('drawerToggled', event => {
    switch (event.drawer.id) {
      case 'uploads':
        store.dispatch('globals_drawer_toggle', {
          id: 'upload-boxes',
          tab: event.drawer.tab,
        })
        break

      case 'handDetails':
        store.dispatch('globals_drawer_toggle', {
          id: 'analyze_handV4',
          content: {
            hand_id: event.drawer.hand_id,
          },
        })
        break
      default:
        // Unknown drawer toggled
        break
    }
  })

  apiBridge.on('logout', () => {
    store.dispatch('api_logout')
  })

  solutionBridge.on('createSolution', () => {
    store.commit('globals_set', { key: 'floating_gmf_visible', value: true })

    store.dispatch(SNK('sol_switchSolTypeNEW', namespaces.STUDY), {
      namespace: namespaces.STUDY,
      channelId: `floating_gmf_${Date.now()}`,
      gmfs_solution_tab: 'ai_sols',
      solType: 'custom',
    })
  })
}
